import { useEffect, useState } from 'react';

/**
 * The value, held back until it has stopped changing for `delay` ms.
 *
 * List pages fetch on every change of their search term. Wiring the input
 * straight to the request fires one round trip per keystroke; making the user
 * press Enter instead (which is what the supplier and registration lists did)
 * avoids that at the cost of a search box that looks broken until you find the
 * key. Debouncing gives the live behaviour without the traffic.
 */
export const useDebouncedValue = (value, delay = 300) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
};

export default useDebouncedValue;
